import styled from 'styled-components'

interface ReviewItemDesktopProps {
  postTitle: string
  userNickname: string
}

const ReviewItemDesktop = ({
  postTitle,
  userNickname,
}: ReviewItemDesktopProps) => {
  return (
    <StyledWrapper>
      <p className="post-title">{postTitle}</p>
      <p className="user-nickname">{userNickname}</p>
    </StyledWrapper>
  )
}

export default ReviewItemDesktop

const StyledWrapper = styled.button`
  cursor: pointer;
  width: 668px;
  height: 62px;
  padding: 0px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  border-top: 1px solid #eeeeee;

  > .post-title {
    max-width: 80%;
    text-align: left;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: -0.64px;
    color: #333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  > .user-nickname {
    width: 140px;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: -0.64px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
